import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { isNil } from 'lodash-es';

/** Composite operation item used by the picker — covers host's own ops (referenceName=null)
 *  and ref'd module ops (referenceName=set). Shape mirrors what the role-edit consumer
 *  needs back when pushing to AuthorizationRole.assignedOperations[]. */
export interface IPickerOperation {
  name: string;
  applicationReferenceName: string | null;
  description: string;
  isAuthorizable: boolean;
}

export interface IOperationSelectFormParams {
  /** Available pool the user picks from. Caller pre-filters out already-assigned ops. */
  available: IPickerOperation[];
}

@Component({
  selector: 'app-operation-select-form',
  templateUrl: './operation-select-form.component.html',
  standalone: false
})
export class OperationSelectFormComponent implements OnInit {
  selected: IPickerOperation[] = [];
  allowSelection = true;

  list: IPickerOperation[];

  constructor(
    private dialogRef: MatDialogRef<OperationSelectFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IOperationSelectFormParams,
  ) { }

  ngOnInit(): void {
    this.filter();
  }

  onSaveClicked() {
    this.dialogRef.close(this.selected);
  }

  onCancelClicked() {
    this.dialogRef.close();
  }

  filter(fullTextSearch?: string) {
    if (!isNil(fullTextSearch) && fullTextSearch.length > 0) {
      const text = fullTextSearch.toLocaleLowerCase();
      this.list = this.data.available.filter(o => o.name.toLocaleLowerCase().includes(text));
    } else {
      this.list = [...this.data.available];
    }
  }

  /** Stable identity for the grid's selection model: (refName ?? "") + ":" + name */
  isSameOperation = (a: IPickerOperation, b: IPickerOperation): boolean => {
    return (a.applicationReferenceName ?? '') === (b.applicationReferenceName ?? '')
      && a.name === b.name;
  };
}
